export const keyboard_shortcuts_data = [
    {
        title: 'Навигация по приложению',
        shortcuts: [
            {
                key: 'i',
                text: 'Открыть сим-карты',
            },
            {
                key: 'a',
                text: 'Открыть аккаунт',
            },
            {
                key: 'h',
                text: 'Открыть поддержку',
            },
            {
                key: 'b',
                text: 'Открыть сводку',
            },
            {
                key: 'm',
                text: 'Открыть карту',
            },
            {
                key: 'e',
                text: 'Открыть события',
            },
            {
                key: '?',
                text: 'Открыть горячие клавиши',
            },
        ],
    },
    {
        title: 'Навигация по устройству',
        shortcuts: [
            {
                key: 's',
                text: 'Открыть настройки устройства',
            },
            // {
            //     key: 'c',
            //     text: 'Замена устройства',
            // },
            // {
            //     key: 'r',
            //     text: 'Удалить устройство',
            // },
            {
                key: 'n',
                text: 'Добавить устройство',
            },
            {
                key: 'd',
                text: 'Выбрать устройства',
            },
            {
                key: '↑ ↓',
                text: 'Перемещение по устройствам',
            },
            {
                key: '← →',
                text: 'Перемещение по вкладкам',
            },
        ],
    },
    {
        title: 'Навигация по элементам управления',
        shortcuts: [
            {
                key: '← → ↑ ↓',
                text: 'Перемещение по элементам',
            },
            {
                key: 'shift + h',
                text: 'Выбрать контуры',
            },
            {
                key: 'shift + b',
                text: 'Выбрать котлы',
            },
            {
                key: 'shift + c',
                text: 'Выбрать пользовательские элементы',
            },
            {
                key: 'shift + t',
                text: 'Выбрать термометры',
            },
            {
                key: 'shift + s',
                text: 'Выбрать датчики',
            },
            {
                key: 'shift + r',
                text: 'Выбрать радиодатчики',
            },
            {
                key: 'shift + v',
                text: 'Выбрать элементы управления машины',
            },
            {
                key: 'shift + z',
                text: 'Выбрать охранные зоны',
            },
            {
                key: 'shift + g',
                text: 'Выбрать управление охраной',
            },
            {
                key: 'shift + m',
                text: 'Выбрать отопительные режимы',
            },
            {
                key: 'shift + n',
                text: 'Выбрать котловые режимы',
            },
        ],
    },
];
